import { createContext } from "react";

export interface ReferrerContextProps {
  referrer: string;
}

export const ReferrerContext = createContext<string>("");
export default ReferrerContext;
